import React from 'react'
import 'App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRouter from './routers/PrivateRouter';
import Contactus from 'pages/Contactus';

// banner
import BannerList from 'pages/banner/List';
import AddBanner from 'pages/banner/Add';
import UpdateBanner from 'pages/banner/Update';

// gallery
import GalleryList from 'pages/gallery/List';
import AddGallery from 'pages/gallery/Add';
import ListVideo from 'pages/gallery/ListVideo';
import AddVideo from 'pages/gallery/AddVideo';

//users
import UsersList from 'pages/users/UsersList';
import UpdateUser from 'pages/users/UpdateUser';

// startups & mentors
import ListStartups from 'pages/startups/ListStartups';
import AddStartup from 'pages/startups/AddStartup';
import EditStartup from 'pages/startups/EditStartup';
import ViewStartup from 'pages/startups/ViewStartup';
import ListMentors from 'pages/mentors/ListMentors';
import AddMentor from 'pages/mentors/AddMentor';
import EditMentor from 'pages/mentors/EditMentor';
import ViewMentor from 'pages/mentors/ViewMentor';

// programs
import ListPrograms from 'pages/programs/ListPrograms';
import AddProgram from 'pages/programs/AddProgram';
import UpdateProgram from 'pages/programs/UpdateProgram';

// events
import ListEventCategories from 'pages/events/ListEventCategories';
import AddEventCategory from 'pages/events/AddEventCategory';
import ListEventFiles from 'pages/events/ListEventFiles';
import AddEventFile from 'pages/events/AddEventFile';

// news
import ListNews from 'pages/news/ListNews';
import AddNews from 'pages/news/AddNews';
import UpdateNews from 'pages/news/UpdateNews';

// success stories
import ListStories from 'pages/stories/ListStories';
import AddStory from 'pages/stories/AddStory';
import UpdateStory from 'pages/stories/UpdateStory';

// team
import TeamMembers from 'pages/team/TeamMembers';

// downloads
import ListCategories from 'pages/downloads/ListCategories';
import AddCategory from 'pages/downloads/AddCategory';
import ListDownloadFiles from 'pages/downloads/ListDownloadFiles';
import AddDownloadFile from 'pages/downloads/AddDownloadFile';

// faq
import ManageFaqFiles from 'pages/faq/ManageFaqFiles';

// visitors
import VisitorList from 'pages/visitors/VisitorList';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/signin" element={<Login />} />
        <Route path="/" element={<Login />} />

        <Route element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Home />} />
          
          {/* Team */}
          <Route path="/team" element={<TeamMembers />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/qr-visitors" element={<VisitorList />} />

          {/* banner */}
          <Route path="/banner" element={<BannerList />} />
          <Route path="/banner/add" element={<AddBanner />} />
          <Route path="/banner/update/:id" element={<UpdateBanner />} />

          {/* gallery */}
          <Route path="/gallery" element={<GalleryList />} />
          <Route path="/gallery/add" element={<AddGallery />} />
          <Route path="/gallery/video" element={<ListVideo />} />
          <Route path="/gallery/video/add" element={<AddVideo />} />

          {/* user  */}
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/update/:id" element={<UpdateUser />} />

          {/* startups & mentors */}
          <Route path="/startups" element={<ListStartups />} />
          <Route path="/startups/add" element={<AddStartup />} />
          <Route path="/startups/edit/:id" element={<EditStartup />} />
          <Route path="/startups/view/:id" element={<ViewStartup />} />
          <Route path="/mentors" element={<ListMentors />} />
          <Route path="/mentors/add" element={<AddMentor />} />
          <Route path="/mentors/edit/:id" element={<EditMentor />} />
          <Route path="/mentors/view/:id" element={<ViewMentor />} />

          {/* programs */}
          <Route path="/programs" element={<ListPrograms />} />
          <Route path="/programs/add" element={<AddProgram />} />
          <Route path="/programs/update/:id" element={<UpdateProgram />} />

          {/* events */}
          <Route path="/events/categories" element={<ListEventCategories />} />
          <Route path="/events/categories/add" element={<AddEventCategory />} />
          <Route path="/events/files" element={<ListEventFiles />} />
          <Route path="/events/files/add" element={<AddEventFile />} />

          {/* news */}
          <Route path="/news" element={<ListNews />} />
          <Route path="/news/add" element={<AddNews />} />
          <Route path="/news/update/:id" element={<UpdateNews />} />

          {/* success stories */}
          <Route path="/stories" element={<ListStories />} />
          <Route path="/stories/add" element={<AddStory />} />
          <Route path="/stories/update/:id" element={<UpdateStory />} />

          {/* downloads */}
          <Route path="/downloads/categories" element={<ListCategories />} />
          <Route path="/downloads/categories/add" element={<AddCategory />} />
          <Route path="/downloads/files" element={<ListDownloadFiles />} />
          <Route path="/downloads/files/add" element={<AddDownloadFile />} />

          {/* FAQ */}
          <Route path="/faq-files" element={<ManageFaqFiles />} />

          <Route path="/*" element={<h1>No page avaliable</h1>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
